import { registerBlockType } from '@wordpress/blocks';
import metadata from './block.json';
import Save from './save';
import Edit from './edit';

registerBlockType( metadata.name, {
	edit: Edit,
	save: Save,
	icon: {
		foreground: '#0061FE',
		src: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
				width="24"
				height="24"
				fill="currentColor"
			>
				<circle cx="4" cy="12" r="3" />
				<rect x="10" y="6" width="12" height="12" rx="2" />
			</svg>
		),
	},
} );
